module.exports = "/_next/static/images/Security-xs-16735e3b01d704755f6cdd09db3236d5.webp";